import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { collapsed: Boolean }
  connect() {
    // If the cookie isn't present, fall back to localStorage
    if (!document.cookie.includes("sidebar_collapsed=") && localStorage.getItem("sidebar-collapsed") !== null) {
      this.collapsedValue = localStorage.getItem("sidebar-collapsed") === "true"
    }
  }
  toggle() {
    this.collapsedValue = !this.collapsedValue
  }

  collapsedValueChanged(isCollapsed) {
    this.element.classList.toggle("w-16", isCollapsed)
    this.element.classList.toggle("w-64", !isCollapsed)

    const mainContent = document.getElementById("main-content")
    if (mainContent) {
      mainContent.classList.toggle("lg:ps-16", isCollapsed)
      mainContent.classList.toggle("lg:ps-64", !isCollapsed)
    }

    this.setCookie("sidebar_collapsed", isCollapsed, 365)
    localStorage.setItem("sidebar-collapsed", isCollapsed)
  }

  setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString()
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`
  }
}